import React, { useRef } from "react";
import { Editor } from "@tinymce/tinymce-react";
import { authApiService } from "../../api/api";
import styles from "./styles.module.scss";

interface Props {
  value: string;
  onChange: (value: string) => void;
}

const TinyMceEditor: React.FC<Props> = ({ value, onChange }) => {
  const editorRef = useRef<any>(null);

  return (
    <div className={styles.container}>
      <label className={styles.label}>
        Content <span className={styles.require}>*</span>
      </label>
      <Editor
        apiKey={process.env.REACT_APP_TINYMCE_API_KEY}
        onInit={(_evt, editor) => {
          editorRef.current = editor;
        }}
        value={value}
        onEditorChange={(content) => onChange(content)}
        init={{
          height: 420,
          menubar: false,
          plugins: [
            "advlist",
            "autolink",
            "lists",
            "link",
            "image",
            "charmap",
            "preview",
            "anchor",
            "searchreplace",
            "visualblocks",
            "code",
            "fullscreen",
            "insertdatetime",
            "media",
            "table",
            "help",
            "wordcount",
          ],
          toolbar:
            "undo redo | blocks | bold italic underline | alignleft aligncenter alignright | bullist numlist | link image | removeformat | code",
          content_style:
            "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
          images_upload_handler: async (blobInfo: {
            blob: () => Blob;
            filename: () => string;
          }) => {
            const formData = new FormData();
            formData.append("file", blobInfo.blob(), blobInfo.filename());
            const response = await authApiService.uploadImage(formData);
            if (!response?.publicUrl) {
              throw new Error("Image upload failed");
            }
            return response.publicUrl;
          },
          automatic_uploads: true,
          file_picker_types: "image",
        }}
      />
    </div>
  );
};

export default TinyMceEditor;
